import script from "./IconLights.vue?vue&type=script&setup=true&lang=js"
export * from "./IconLights.vue?vue&type=script&setup=true&lang=js"

import "./IconLights.vue?vue&type=style&index=0&id=fa2832f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa2832f0"]])

export default __exports__